import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = ['sentinel', 'spinner', 'nextPage'];

  connect() {
    this.loading = false;
    this.setupObserver();
  }

  disconnect() {
    this.teardownObserver();
  }

  nextPageTargetConnected() {
    this.setupObserver();
  }

  nextPageTargetDisconnected() {
    this.teardownObserver();
    this.removeSentinel();
    this.hideSpinner();
  }

  get nextUrl() {
    if (!this.hasNextPageTarget) return null;
    return this.nextPageTarget.dataset.url || null;
  }

  setupObserver() {
    this.teardownObserver();
    if (!this.hasSentinelTarget || !this.nextUrl) return;

    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      {rootMargin: '200px'}
    );
    this.observer.observe(this.sentinelTarget);
  }

  teardownObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  async handleIntersect(entries) {
    const entry = entries[0];
    if (!entry.isIntersecting || this.loading || !this.nextUrl) return;

    this.loading = true;
    this.showSpinner();

    try {
      const response = await fetch(this.nextUrl, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
      });

      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
      }
    } catch {
      this.removeSentinel();
    } finally {
      this.loading = false;
      this.hideSpinner();
    }
  }

  removeSentinel() {
    if (this.hasSentinelTarget) {
      this.sentinelTarget.remove();
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none');
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('d-none');
    }
  }
}
